import config from "../../helpers/config.helper";

const appConfig = config();
const dateTimeFormat = appConfig.REACT_APP_DATE_TIME_FORMAT;

export type Options = {
    title: any;
    axisX: any,
    axisY: any,
    toolTip?: any,
    data: DataObj[],
    height: number,
    //width: number,
    zoomEnabled: boolean,
    interactivityEnabled: boolean,
    animationEnabled: boolean,
    exportEnabled: boolean,
    culture: string
}

export type Map<T> = {
    [id: number]: T;
}

export type DataPoint = { x: any, y?: any };

export type DataObj = {
    type: string;
    id: string;
    showInLegend?: boolean;
    name?: string;
    xValueFormatString?: string;
    yValueFormatString?: string;
    dataPoints: Array<DataPoint>
}

export const initOptions: Options = {
    title: {
        text: "",
        fontSize: 15,
        fontFamily: "sans-serif"
    },
    toolTip:{   
        content: "{x} <br/>{y}"  
    },
    axisX: {
        title: "",
        valueFormatString: "DD-MMM",
        interval: 2,
        intervalType: "day",
        labelFontSize: 13,
        labelFontFamily: "sans-serif",
        labelFontColor: "#131313",
        titleFontSize: 13,
        titleFontFamily: "sans-serif",
        lineThickness: 2,
        lineColor: "#999",
        tickColor: "#999",
        tickThickness : 1
    },
    axisY: {
        title: "Data",
        titleFontColor: "#131313",
        labelFontSize: 13,
        labelFontFamily: "sans-serif",
        labelFontColor: "#131313",
        titleFontSize: 13,
        titleFontFamily: "sans-serif",
        gridColor: "#999",
        gridThickness: 1,
        lineThickness: 2,
        lineColor: "#999",
        tickColor: "#999",
        tickThickness : 1
    },
    height: 550,
    data: [
        {
            xValueFormatString:dateTimeFormat,
            type: "line",
            id: "0_0",
            dataPoints: [],
        },
    ],
    zoomEnabled: true,
    interactivityEnabled: true,
    animationEnabled: true,
    exportEnabled: true,
    culture: "en"
};